import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CorrespondanceMarque } from '../../core/models/correspondance.model';

@Injectable({ providedIn: 'root' })
export class MarquesService {
  private readonly http = inject(HttpClient);

  getByCodeMarque(codeMarque: string): Observable<CorrespondanceMarque> {
    return this.http.get<CorrespondanceMarque>(
      `${environment.apiBaseUrl}/correspondance-marques/${encodeURIComponent(codeMarque)}`
    );
  }

  updateMarque(
    codeMarque: string,
    updates: Record<string, string>
  ): Observable<CorrespondanceMarque> {
    return this.http.put<CorrespondanceMarque>(
      `${environment.apiBaseUrl}/correspondance-marques/${encodeURIComponent(codeMarque)}`,
      updates
    );
  }

  createMarque(data: Record<string, unknown>): Observable<{ message: string; code_marque: string }> {
    return this.http.post<{ message: string; code_marque: string }>(
      `${environment.apiBaseUrl}/correspondance-marques`,
      data
    );
  }

  deleteMarque(codeMarque: string): Observable<{ message: string; code_marque: string }> {
    return this.http.delete<{ message: string; code_marque: string }>(
      `${environment.apiBaseUrl}/correspondance-marques/${encodeURIComponent(codeMarque)}`
    );
  }

  listAll(): Observable<{ items: { code_marque: string; libelle_marque?: string }[] }> {
    return this.http.get<{ items: { code_marque: string; libelle_marque?: string }[] }>(
      `${environment.apiBaseUrl}/correspondance-marques`
    );
  }

  uploadLogo(
    codeMarque: string,
    file: File
  ): Observable<{ message: string; code_marque: string; logo_presigned_url: string | null }> {
    return this.http.put<{ message: string; code_marque: string; logo_presigned_url: string | null }>(
      `${environment.apiBaseUrl}/correspondance-marques/${encodeURIComponent(codeMarque)}/logo`,
      file,
      { headers: { 'Content-Type': file.type } }
    );
  }
}
